module.exports = __webpack_public_path__ + "img/Women’s Probiotic.6a469776.png";